// client/src/components/admin/advertiser/AdvertiserInfoList.js
import React, { useState, useEffect } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdvertiserInfoList({ onSelect, selectedId, search }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 20;

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search]);

  const fetchList = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page,
        pageSize,
        search: search || ''
      });

      const res = await fetch(`${API_URL}/api/admin/advertiser/info/list?${params}`, {
        credentials: 'include'
      });
      const data = await res.json();

      if (data.ok) {
        setItems(data.items || []);
        setTotalPages(data.totalPages || 0);
      }
    } catch (error) {
      console.error('fetchList error:', error);
    }
    setLoading(false);
  };

  const getTypeLabel = (type) => {
    const labels = {
      'corporate': '법인',
      'sole': '개인사업자',
      'agency': '광고사',
      'freelancer': '프리랜서'
    };
    return labels[type] || type;
  };

  return (
    <div className="admin-list">
      <div className="admin-list__header">
        광고주 목록
      </div>

      <div className="admin-list__body">
        {loading ? (
          <div className="admin-list__loading">
            불러오는 중...
          </div>
        ) : items.length === 0 ? (
          <div className="admin-list__empty">
            광고주가 없습니다.
          </div>
        ) : (
          <div>
            {items.map((item) => (
              <div
                key={item._id}
                onClick={() => onSelect(item)}
                className={`admin-list__item ${
                  selectedId === item.userId ? 'admin-list__item--selected' : ''
                }`}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {item.userId} <span className="admin-list__item-sub">({item.userName})</span>
                  </div>
                  <div className="admin-list__item-badge admin-list__item-badge--primary">
                    {getTypeLabel(item.type)}
                  </div>
                </div>
                <div className="admin-list__item-meta" style={{ marginTop: '4px' }}>
                  가입: {new Date(item.registeredAt).toLocaleDateString('ko-KR')}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 페이지네이션 */}
      {totalPages > 1 && (
        <div className="admin-list__pagination">
          <div className="admin-list__pagination-info">
            {page} / {totalPages}
          </div>
          <div className="admin-list__pagination-buttons">
            <button
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="admin-list__pagination-button"
            >
              ◀
            </button>
            <button
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
              className="admin-list__pagination-button"
            >
              ▶
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdvertiserInfoList;
